export default __webpack_public_path__ + "static/media/ascend-background.770154e3.png";